/**
 * Blurb w/ Contact and Menu
 */

import * as React from "react";
import { Link } from "gatsby";
import Img from "./img";
import Content from "./content";
import MenuDonors from "./menu-donors";
import MenuProfessionalAdvisors from "./menu-professional-advisors";
import MenuNonprofits from "./menu-nonprofits";
import MenuCommunity from "./menu-community";
import MenuAbout from "./menu-about";
import MenuNews from "./menu-news";
import MenuPosts from "./menu-posts";
import "../styles/blurb-menu.css";

const BlurbMenu = ({ props, location, menuProp }) => {
  const heading = props?.field_blurb_heading;
  const content =
    props?.field_blurb_content?.processed || props?.body?.processed;
  const link = props?.relationships?.field_blurb_link?.path?.alias;
  const label = props?.field_blurb_link_label;
  const contentEnd = props?.field_blurb_content_end?.processed;
  const contact = props?.relationships?.field_blurb_contact;
  const menu = props?.field_blurb_menu || menuProp;
  const imageSize = menuProp ? "lg" : "default";
  const localFile =
    props?.relationships?.field_blurb_icon?.relationships?.field_media_image
      ?.localFile ||
    props?.relationships?.field_image?.relationships?.field_media_image
      ?.localFile;
  const imageAlt =
    props?.relationships?.field_blurb_icon?.field_media_image?.alt ||
    props?.relationships?.field_image?.field_media_image?.alt;
  const hideImage = props?.relationships?.field_categories?.filter(
    (category) => category?.name === "Videos"
  ).length;
  const isStaff = props?.relationships?.field_department?.length;

  return (
    <div className={`bg-gray-50 py-12 sm:py-16`}>
      <div className="container grid lg:grid-cols-3 gap-12 xl:gap-14 mb-4">
        <div
          className={`${
            menu ? "lg:col-span-2" : "lg:col-span-3"
          } bg-white rounded p-8 lg:px-12 lg:py-10`}
        >
          <div className="sm:flex items-center">
            {heading && <h2 className={`text-red`}>{heading}</h2>}
            {!hideImage && localFile && (
              <Img
                localFile={localFile}
                imageAlt={imageAlt}
                objectFit="contain"
                className={`block rounded mb-4 ${
                  imageSize === "lg"
                    ? "w-full max-h-screen h-auto"
                    : "w-auto h-24 ml-8 mt-4 sm:-mt-4"
                }`}
              />
            )}
          </div>
          {isStaff ? <BlurbStaff props={props} /> : null}
          {content || (link && label) ? (
            <div className="mb-8">
              {content && (
                <div className="mb-4">
                  <Content props={content} />
                </div>
              )}
              {link && label ? (
                <Link className={`btn btn-red`} to={link}>
                  {label}
                </Link>
              ) : null}
            </div>
          ) : null}

          {contact && <BlurbContact props={contact} />}

          {contentEnd && (
            <div className="mt-8">
              <Content props={contentEnd} />
            </div>
          )}
        </div>
        {menu && (
          <div className="hidden lg:block">
            <div className="bg-white rounded p-6 xl:px-8 blurb-menu">
              {menu === "donors" ? (
                <MenuDonors location={location} />
              ) : menu === "professionalAdvisors" ? (
                <MenuProfessionalAdvisors location={location} />
              ) : menu === "nonprofits" ? (
                <MenuNonprofits location={location} />
              ) : menu === "community" ? (
                <MenuCommunity location={location} />
              ) : menu === "about" ? (
                <MenuAbout location={location} />
              ) : menu === "news" ? (
                <MenuNews location={location} />
              ) : menu === "posts" ? (
                <MenuPosts location={location} />
              ) : null}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const BlurbContact = ({ props }) => {
  const localFile =
    props?.relationships?.field_contact_image?.relationships?.field_media_image
      ?.localFile;
  const imageAlt =
    props?.relationships?.field_contact_image?.field_media_image?.alt;
  const email = props?.field_contact_email;
  const firstName = props?.field_contact_first_name;
  const name = props?.field_contact_name;
  const title = props?.field_contact_title;
  const phone = props?.field_contact_phone;
  const content = props?.field_contact_content?.processed;
  const imageFocus = props?.field_image_focus || "center 25%";
  return (
    <>
      {(localFile || email || firstName || title || phone || content) && (
        <div className="flex flex-wrap">
          {localFile && (
            <div className="relative mr-6">
              <Img
                localFile={localFile}
                imageAlt={imageAlt}
                className="rounded-full border-red bg-red border-4 w-44 h-44 overflow-hidden"
                style={{ perspective: "1px" }}
                imgClassName="rounded-full"
                objectPosition={imageFocus}
              />
            </div>
          )}
          <div className="flex-1">
            {(name || title) && (
              <h2 className="">
                Contact {name}
                {title ? ", " + title : ""}
              </h2>
            )}
            {content && (
              <div className="mb-4">
                <Content props={content} />
              </div>
            )}

            {email && (
              <a
                className={`btn btn-red mr-5 mb-4`}
                target="_blank"
                rel="noreferrer"
                href={`mailto:${email}`}
              >
                Email {firstName || name}
              </a>
            )}
            {phone && (
              <a
                className={`btn btn-green`}
                target="_blank"
                rel="noreferrer"
                href={`tel:${phone}`}
              >
                Call {phone?.replace(/,/g, " Ext. ")}
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const BlurbStaff = ({ props }) => {
  const localFile =
    props?.relationships?.field_staff_image?.relationships?.field_media_image
      ?.localFile;
  const imageAlt =
    props?.relationships?.field_staff_image?.field_media_image?.alt;
  const email = props?.field_staff_email;
  const name = props?.title;
  const title = props?.field_staff_title;
  const phone = props?.field_staff_phone_number;
  const imageFocus = props?.field_staff_image_focus;
  return (
    <>
      {(localFile || email || title || phone) && (
        <div className="flex flex-wrap">
          {localFile && (
            <div className="relative mr-6 mb-4">
              <Img
                localFile={localFile}
                imageAlt={imageAlt}
                className="rounded-full border-red bg-red border-4 w-44 h-44 overflow-hidden relative"
                style={{ perspective: "1px" }}
                objectPosition={imageFocus}
              />
            </div>
          )}
          <div className="flex-1">
            {name && <h2 className="">{name}</h2>}
            {title && <h2 className="subheading text-red mb-6">{title}</h2>}
            {email && (
              <a
                className={`btn btn-red mr-5 mb-4`}
                target="_blank"
                rel="noreferrer"
                href={`mailto:${email}`}
              >
                Email {email}
              </a>
            )}
            {phone && (
              <a
                className={`btn btn-green`}
                target="_blank"
                rel="noreferrer"
                href={`tel:${phone}`}
              >
                Call {phone?.replace(/,/g, " Ext. ")}
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BlurbMenu;
